import { Account } from '../../../../models/admin/account';

export class EventCountModalData {
  constructor(public account: Account) {}
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/admin/accounts/event.count/event.count.modal.provider.ts